import { BASE_URL } from "@/constants/constants";
import MainLayout from "@/layouts/MainLayout";
import Home from "@/pages/home/Home.page";
import { Capture } from "@/pages/capture/Capture.page";
import { createBrowserRouter, redirect } from "react-router-dom";
import AdminLayout from "@/layouts/AdminLayout";
import CreateGarage from "@/pages/capture/garage/create-garage/CreateGarage";
import NewGroupPage from "@/pages/capture/garage/new-group/NewGroupPage";
import ResumePage from "@/pages/capture/garage/resume/Resume.page";
import EditionGroupPage from "@/pages/capture/garage/edition/EditionGroupPage";
import ReceptionNewGroupPage from "@/pages/capture/reception/reception-new-group/ReceptionNewGroupPage";
import CreateReception from "@/pages/capture/reception/create-reception/CreateReception";
import ReceptionResumePage from "@/pages/capture/reception/recepction-resume/ReceptionResume.page";
import ReceptionEditionGroupPage from "@/pages/capture/reception/reception-edition/ReceptionEditionGroupPage";
import ReceptionPackagingEdition from "@/pages/capture/reception/reception-packaging-edition/ReceptionPackagingEdition";
import CreateExits from "@/pages/capture/exits/create-exits/CreateExits";
import ExitsNewGroupPage from "@/pages/capture/exits/exits-new-group/ExitsNewGroupPage";
import ExitsResumePage from "@/pages/capture/exits/exits-resume/ExistsResume.page";
import ExistEditionGroupPage from "@/pages/capture/exits/exits-edition/ExistEditionGroupPage";
import LayoutPhotosResults from "@/pages/admin/PhotosResults.layout";
import Unauthorized from "@/pages/error/Unauthorized";
import NotFound from "@/pages/error/NotFound";
import RouterErrorBoundary from "@/pages/error/RouterErrorBoundary";
import AppAuthWithErrorBoundary from "@/pages/error/AppAuthWithErrorBoundary";
import LayoutRequests from "@/pages/admin/Requests.layout";
import DeveloperPage from "@/pages/developer/Developer.page";

export const createAppRouter = () =>
  createBrowserRouter([
    {
      path: BASE_URL,
      Component: AppAuthWithErrorBoundary,
      errorElement: <RouterErrorBoundary />,
      children: [
        {
          path: BASE_URL,
          Component: MainLayout,
          children: [
            {
              index: true,
              Component: Home,
            },
            {
              path: "capture",
              children: [
                { index: true, Component: Capture },
                {
                  path: "garage",
                  children: [
                    {
                      index: true,
                      Component: CreateGarage,
                    },
                    {
                      path: "new-group",
                      Component: NewGroupPage,
                    },
                    {
                      path: "resume",
                      Component: ResumePage,
                    },
                    {
                      path: "edition/:groupId",
                      Component: EditionGroupPage,
                    },
                  ],
                },
                {
                  path: "reception",
                  children: [
                    {
                      index: true,
                      Component: CreateReception,
                    },
                    {
                      path: "new-group",
                      Component: ReceptionNewGroupPage,
                    },
                    {
                      path: "resume",
                      Component: ReceptionResumePage,
                    },
                    {
                      path: "edition/:groupId",
                      Component: ReceptionEditionGroupPage,
                    },
                    {
                      path: "packaging",
                      Component: ReceptionPackagingEdition,
                    },
                  ],
                },
                {
                  path: "exits",
                  children: [
                    {
                      index: true,
                      Component: CreateExits,
                    },
                    {
                      path: "new-group",
                      Component: ExitsNewGroupPage,
                    },
                    {
                      path: "resume",
                      Component: ExitsResumePage,
                    },
                    {
                      path: "edition/:groupId",
                      Component: ExistEditionGroupPage,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: `${BASE_URL}/admin`,
          Component: AdminLayout,
          children: [
            { path: "photos", Component: LayoutPhotosResults, index: true },
            { path: "requests", Component: LayoutRequests },
          ],
        },
        {
          path: `${BASE_URL}/developer`,
          Component: DeveloperPage,
        },
        {
          path: `${BASE_URL}/*`,
          loader: () => redirect(BASE_URL),
        },
      ],
    },
    {
      path: `unauthorized`,
      Component: Unauthorized,
    },
    {
      path: `*`,
      Component: NotFound,
    },
  ]);

const router = createAppRouter();
export default router;
